import isEqual from 'lodash/isEqual';
import groupBy from 'lodash/groupBy';
import { Preference } from '../../../../../models/Preference';
import { isAnalystTag, isReportTag } from '../../../../../utils/tagUtils';
import { FORM_FIELD_NAMES } from './AddPreferencesModal.constants';
import { AddPreferencesFormModel } from './AddPreferencesModal.types';
import { GENERIC_ERROR_TEXT } from '../../../../../Base.constants';

export const isPreferencesUnique = (newPreference: Preference, preferences?: Preference[]): boolean => {
  if (!preferences?.length) {
    return true;
  }

  return groupMappedPreference(newPreference).every(
    ({ tags }) => !preferences.some(({ tags: existingTags }) => isEqual(existingTags, tags))
  );
};

export const isFormSaveBtnDisabled = (
  isLoading: boolean,
  isSaving: boolean,
  formValues: AddPreferencesFormModel,
  error?: string
): boolean => {
  return (
    isLoading ||
    isSaving ||
    (!!error && error !== GENERIC_ERROR_TEXT) ||
    !(
      formValues.subsector ||
      formValues[FORM_FIELD_NAMES.creditGrade] ||
      formValues[FORM_FIELD_NAMES.region] ||
      formValues[FORM_FIELD_NAMES.sector] ||
      formValues[FORM_FIELD_NAMES.topic] ||
      formValues[FORM_FIELD_NAMES.report] ||
      formValues[FORM_FIELD_NAMES.analyst] ||
      formValues[FORM_FIELD_NAMES.assetClass]
    )
  );
};

export const mapFormValuesToPreference = (formValues: AddPreferencesFormModel): Preference => {
  const tagsIds: string[] = Object.values(formValues).filter((value) =>
    typeof value === 'string' ? value.includes('/') : false
  );

  return {
    myCS: formValues.myCS,
    mode: formValues.mode,
    tags: tagsIds.sort(),
    modeCovenants: formValues.mode,
    modeNews: formValues.mode,
    modeResearch: formValues.mode,
  };
};

export const groupMappedPreference = (preference: Preference): Preference[] => {
  const groups = groupBy(preference.tags, (tag) => {
    if (isAnalystTag(tag)) {
      return 0;
    }
    if (isReportTag(tag)) {
      return 1;
    }
    return 2;
  });

  return Object.entries(groups).map(([, tags]) => ({
    ...preference,
    tags,
  }));
};
